<template>
  <div id="style-2" class="my-2 mx-5 d-block overflow-auto">
    <div>
      <table class="tutor-study-result-table" v-if="computedDataPracticeSkill.length > 0 && (activeProgramSubjectId === 5 && !isTaSGK) && !loading">
        <thead>
        <tr>
          <th>Mã lớp</th>
          <th style="min-width: 200px; max-width: 200px" rowspan="2">Ngày kiểm tra</th>
          <th style="min-width: 150px; max-width: 150px">Buổi học kiểm tra</th>
          <th v-for="(skill, index) in testSkill" :key="skill + index">{{skill}}</th>
        </tr>
        </thead>
        <tbody>
        <template v-for="item in computedDataPracticeSkill">
          <tr :key="item.classCode">
            <td rowspan="2">{{item.classCode}}</td>
            <td rowspan="2">{{item.testDate}}</td>
            <td rowspan="2" style="border-right: 1px solid #9747FF33; text-align: left">
              <div style="position: relative">
                {{item.lessonTested}}
                <span v-if="checkTestResult(item.testResult)" style="cursor: pointer; position: absolute; right: 0; top: -20px" @click="showScoreDetail(item)"><v-icon dense>mdi-information-outline</v-icon></span>
              </div>
            </td>
            <td v-for="skill in testSkill" :key="skill + 'tr'" >
              <span style="font-weight: bold" v-if="getSkillPointByName(item.testResult, skill).totalQuestion !== null">{{getSkillPointByName(item.testResult, skill).totalCorrectQuestion}}/{{getSkillPointByName(item.testResult, skill).totalQuestion}}</span>
              <span v-else>--</span>
            </td>
          </tr>
          <tr :key="item.classCode + 'tr2'">
            <td v-for="skill in testSkill"
                :key="skill + 'tr'"
                style="border-bottom: 1px solid #9747FF33"
            >
              <div v-if="!(getSkillPointByName(item.testResult, skill).totalCorrectQuestion === null && getSkillPointByName(item.testResult, skill).totalQuestion === null)" class="d-flex justify-center">
                <div class="my-auto">{{parseInt(getSkillPointByName(item.testResult, skill).totalQuestion) !== 0 ? ((parseInt(getSkillPointByName(item.testResult, skill).totalCorrectQuestion)/parseInt(getSkillPointByName(item.testResult, skill).totalQuestion)) * 10).toFixed(2) : 0}}</div>
                <up-down-scope
                  v-if="getSkillPointByName(item.testResult, skill).compareAveragePoint && ['increase','decrease'].includes(getSkillPointByName(item.testResult, skill).compareAveragePoint) && getSkillPointByName(item.testResult, skill).comparePointAveragePoint"
                  :value="getSkillPointByName(item.testResult, skill).comparePointAveragePoint"
                  :kind="getSkillPointByName(item.testResult, skill).compareAveragePoint"
                ></up-down-scope>
              </div>
              <span v-else>--</span>
            </td>
          </tr>
        </template>
        </tbody>
      </table>
      <table class="tutor-study-result-table" v-else-if="nonEnglishData.length > 0 && !loading">
        <thead>
        <tr>
          <th>Mã lớp</th>
          <th style="min-width: 150px; max-width: 150px">Ngày kiểm tra</th>
          <th style="min-width: 150px">Buổi kiểm tra</th>
          <th style="min-width: 150px">Số câu đúng/Tổng số câu</th>
          <th style="min-width: 120px">Điểm trung bình</th>
        </tr>
        </thead>
        <tbody>
        <template v-for="(item) in nonEnglishData">
          <tr v-for="(classDetail, index) in item.lessonList" :key="classDetail.curriculumName + index">

            <td class="text-center">{{classDetail.classCode}}</td>
            <td style="text-align: center">{{classDetail.testDate}}</td>
            <td class="text-left" style="max-width: 250px; min-width: 250px">
              {{classDetail.lessonTested}}
            </td>
            <td class="text-center">
              <div style="position: relative" v-if="!(classDetail.totalQuestion === null && classDetail.totalCorrectQuestion === null)">
                {{classDetail.totalCorrectQuestion ? classDetail.totalCorrectQuestion : 0}}/{{classDetail.totalQuestion}}
                <span v-if="(classDetail.subjectId === 5 && !isTaSGK) && classDetail.isShowDetail" style="cursor: pointer; position: absolute; right: 0; top: -10px" @click="showScoreDetail(classDetail)"><v-icon dense>mdi-information-outline</v-icon></span>
              </div>
              <div v-else>--</div>
            </td>
            <td>
              <div class="d-flex justify-center">
                <div class="mx-auto">{{classDetail.averagePoint ? classDetail.averagePoint.toFixed(2) : '--'}}</div>
                <up-down-scope
                  v-if="classDetail.compareAveragePoint && ['increase','decrease'].includes(classDetail.compareAveragePoint) && classDetail.comparePointAveragePoint"
                  :value="classDetail.comparePointAveragePoint"
                  :kind="classDetail.compareAveragePoint"
                ></up-down-scope>
              </div>

            </td>
          </tr>
        </template>

        </tbody>
      </table>
      <div v-else class="d-flex flex-column justify-center align-center w-100" style="margin-top: 50px">
        <img src="../../assets/close-icon.png" alt="" class="mb-2">
        <img src="../../assets/no-data-exercise.png" alt="" class="mb-5">
        <span style="color: #828282">
            Học sinh chưa có thông tin điểm
        </span>
      </div>
      <div v-if="( nonEnglishData.length > 0 || computedDataPracticeSkill.length > 0 )&& !loading" class="mt-2">
        <span><strong>Ghi chú: </strong></span> <span><i>Tăng, giảm điểm kiểm tra được so sánh với bài kiểm tra liền trước cùng lớp học</i></span>
      </div>
    </div>

    <v-dialog v-model="showDetail" max-width="770">
      <score-detail :curriculumID="curriculumId" :lessonID="lessonId"/>
    </v-dialog>
  </div>
</template>

<script>
import BlendedCareRepository from '@/services/BlendedCareRepository';
import ScoreDetail from '@/modules/student_detail_bt/components/ModalScoreDetail/ScoreDetail.vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import moment from 'moment';
import UpDownScope from '../ModalScoreDetail/UpDownScope.vue';

export default {
  name: 'TestTabTutor',
  components: { ScoreDetail, UpDownScope },
  data() {
    return {
      loading: true,
      dataPracticeSkill: [],
      showDetail: false,
      curriculumId: null,
      lessonId: null,
      testSkill: ['Nghe', 'Nói', 'Đọc', 'Viết'],
    };
  },
  computed: {
    ...mapState('student_detail_bt', ['studentBlendedTutorDetail', 'filterForm', 'activeProgramSubjectId', 'dataPracticeScore', 'activeFilterSubject', 'activeCurriculumId']),
    ...mapGetters('student_care', ['mapProgramIdAndProgram']),
    isTaSGK() {
      return _.get(this.mapProgramIdAndProgram, `[${this.activeCurriculumId}].code`, '') === 'TA-SGK';
    },
    nonEnglishData() {
      return this.dataPracticeScore ? this.dataPracticeScore.filter((e) => e.curriculumName.toLowerCase() === this.activeFilterSubject.toLowerCase()) : [];
    },
    computedDataPracticeSkill() {
      if (this.activeProgramSubjectId === 5) {
        return this.dataPracticeSkill ? this.dataPracticeSkill.filter((e) => this.mapProgramIdAndProgram[e.curriculumId].title.toLowerCase() === this.activeFilterSubject.toLowerCase()) : this.dataPracticeSkill;
      } return [];
    },
  },
  async created() {
    await this.getDataPracticeSkill();
    if (!this.dataPracticeScore) {
      await this.getDataPracticeScore();
    }
  },
  watch: {
    filterForm: {
      deep: true,
      handler() {
        if (this.activeProgramSubjectId === 5 && !this.isTaSGK) {
          this.getDataPracticeSkill();
        } else {
          this.getDataPracticeScore();
        }
      },
    },
  },
  methods: {
    ...mapActions('student_detail_bt', ['setDataPracticeScore']),
    sortByDate(arr) {
      return arr.sort((a, b) => new Date(moment(b.testDate, 'YYYY-MM-DD').format('YYYY-MM-DD')) - new Date(moment(a.testDate, 'YYYY-MM-DD').format('YYYY-MM-DD')));
    },
    checkTestResult(testResult) {
      return testResult ? !testResult.some((e) => e.totalQuestion === null) : false;
    },
    async getDataPracticeScore() {
      this.loading = true;
      if (this.studentBlendedTutorDetail.lms_core_user_id) {
        const loading = this.$loading.show();
        const res = await BlendedCareRepository.getDataPracticeScore({
          id: this.studentBlendedTutorDetail.lms_core_user_id,
          // id: 5326,
          startDate: moment(this.filterForm.dateTime[0]).format('YYYY-MM-DD'),
          endDate: moment(this.filterForm.dateTime[1]).format('YYYY-MM-DD'),
        });
        if (res.message === 'Success') {
          this.setDataPracticeScore(res.data);
        }
        loading.hide();
      }
      this.loading = false;
    },
    showScoreDetail(item) {
      this.showDetail = true;
      this.curriculumId = item.curriculumId;
      this.lessonId = item.lessonId;
    },
    getSkillPointByName(result, name) {
      return result.find((e) => e.name === name);
    },
    async getDataPracticeSkill() {
      if (this.studentBlendedTutorDetail.lms_core_user_id) {
        this.loading = true;
        const loading = this.$loading.show();
        const response = await BlendedCareRepository.getDataPracticeSkill({
          id: this.studentBlendedTutorDetail.lms_core_user_id,
          // id: 1109207,
          startDate: moment(this.filterForm.dateTime[0]).format('YYYY-MM-DD'),
          endDate: moment(this.filterForm.dateTime[1]).format('YYYY-MM-DD'),
        });
        if (response.message === 'Success') {
          this.dataPracticeSkill = response.data;
          this.dataPracticeSkill = this.sortByDate(this.dataPracticeSkill);
        }
        loading.hide();
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.tutor-study-result-table {
  border-spacing: 0;
  width: 100%;
}
.tutor-study-result-table {
  width: 100%;
  max-height: 450px;
  overflow: auto;
  thead {
    position: sticky;
    top: 0;
    z-index: 10;
    tr th {
      min-width: 80px;
      text-align: center;
      padding: 12px 16px;
      background: #4D4CAC;
      color: #fff;
    }
  }
  tbody {
    tr {
      td {
        padding: 16px;
        text-align: center;
        border-bottom: 1px solid #fff;
        background: #F9F4F4;
        color: #000;
      }
    }
  }
}
@media screen and (max-width: 1440px) {
  .tutor-study-result-table {
    font-size: 12px;
    thead {
      tr th {
        padding: 8px 8px;
      }
    }
    tbody {
      tr {
        td {
          padding: 8px;
        }
      }
    }
  }
}
</style>
